import React from "react";
import { Col, Row } from "components/shared/layout";
import styled from "styled-components";
import { fonts } from "assets/fontStyles";
import colours from "assets/colours";
import Button from "components/button";

const Container = styled(Col)`
  padding: 80px 0px 45px 0px;
  max-width: 60%;
  text-align: center;
  margin: 0 auto;
  width: 638px;
  height: 368px;
  justify-content: center;
`;

const Message = styled.div`
  ${fonts.heading5};
  color: ${colours.zltoDarkBlue};
  line-height: 150%;

  span {
    color: ${colours.primary};
  }
`;

const ButtonRow = styled(Row)`
  margin-top: 30px;
  justify-content: center;
  button {
    width: 10em;
    margin: 0px 15px;
  }
`;

const Confirm = ({ setShowModal, rewardAmount, submitDeed, payload }) => (
  <Container>
    <Message>
      {`Submit for review? \nYou will be rewarded ${rewardAmount} ZLTO upon approval by admin.`}
    </Message>
    <ButtonRow>
      <Button variant='zltoLightBlue' onClick={() => submitDeed(payload)}>Yes</Button>
      <Button variant="zltoDarkBlue" onClick={() => setShowModal(null)}>
        No
      </Button>
    </ButtonRow>
  </Container>
);

export default Confirm;
